import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureComparison from './components/FeatureComparison';
import ArticleCards from './components/ArticleCards';
import TrustBlock from './components/TrustBlock';
import CTABanner from './components/CTABanner';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://mulebuyspreadsheets.boutique';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${siteUrl}/#website`,
  name: 'Mulebuy Spreadsheet Hub',
  url: siteUrl,
  description: 'The ultimate Mulebuy Spreadsheet resource hub — tutorials, comparisons, templates, and advanced tracking systems for smarter data management, dropshipping operations, and business scaling in 2026.',
  inLanguage: 'en',
  publisher: {
    '@type': 'Organization',
    name: 'Mulebuy Spreadsheet Hub',
    url: siteUrl,
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <article>
          <CategoryGrid />
        </article>
        <section>
          <FeatureComparison />
        </section>
        <section>
          <ArticleCards />
        </section>
        <section>
          <TrustBlock />
        </section>
        <section>
          <CTABanner />
        </section>
      </main>
      <Footer />
    </div>
  );
}